import { createApp } from 'vue';

export default function renderComponent({ el, component, props }) {
    let app = createApp(component, props);

    app.mount(el);

    return () => {
        // destroy app/component
        app?.unmount();
        app = undefined;
    };
}

export function createElement(element, attribute, inner) {
    if (typeof element === 'undefined') {
        return false;
    }
    if (typeof inner === 'undefined') {
        inner = '';
    }
    var el = document.createElement(element);
    if (typeof attribute === 'object') {
        for (var key in attribute) {
            el.setAttribute(key, attribute[key]);
        }
    }
    if (!Array.isArray(inner)) {
        inner = [inner];
    }
    for (var k = 0; k < inner.length; k++) {
        if (inner[k].tagName) {
            el.appendChild(inner[k]);
        } else {
            el.appendChild(document.createTextNode(inner[k]));
        }
    }
    return el;
}
